import {Component} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';

const /** @type {?} */ EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
/**
 * \@title Input Errors
 */
export class InputErrorsExample {

  emailFormControl = new FormControl('', [
    Validators.required,
    Validators.pattern(EMAIL_REGEX)]);

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'input-errors-example',
  templateUrl: 'input-errors-example.html',
  styleUrls: ['input-errors-example.css'],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputErrorsExample_tsickle_Closure_declarations() {
/** @type {?} */
InputErrorsExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputErrorsExample.ctorParameters;
/** @type {?} */
InputErrorsExample.prototype.emailFormControl;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
